const ENV_TYPE = process.env.NODE_ENV || 'development';

const config = {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8082',
  ENV_TYPE
};

export default config;
